"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlertLevelClass = getAlertLevelClass;
var AlertLevels = {
  None: 0,
  Information: 1,
  Caution: 2,
  Critical: 3,
  Success: 4
};
var AlertLevelClasses = {};
AlertLevelClasses[AlertLevels.None] = 'alert-level-cell';
AlertLevelClasses[AlertLevels.Information] = 'alert-level-cell';
AlertLevelClasses[AlertLevels.Caution] = 'alert-level-cell--warning';
AlertLevelClasses[AlertLevels.Critical] = 'alert-level-cell--critical';
AlertLevelClasses[AlertLevels.Success] = 'alert-level-cell--success';

function getAlertLevelClass(alertLevelId) {
  if (!alertLevelId) {
    return '';
  }

  var alertLevelClass = AlertLevelClasses[alertLevelId];
  return alertLevelClass || '';
}